import React from 'react';
import PropTypes from 'prop-types';
import styles from './IconButton.module.css';

const IconButton = ({ children, size = 'md', active = false, className = '', ...props }) => {
  const classes = [styles.iconButton, styles[size], active ? styles.active : '', className].filter(Boolean).join(' ');

  return (
    <button className={classes} type="button" {...props}>
      {children}
    </button>
  );
};

IconButton.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  active: PropTypes.bool,
  className: PropTypes.string
};

export default IconButton;
